"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _keyMirror = _interopRequireDefault(require("react-utils/keyMirror"));

var _default = (0, _keyMirror.default)({
  ADVISOR_TO_COMPANY: null,
  BOARD_MEMBER_TO_COMPANY: null,
  CONTRACTOR_TO_COMPANY: null,
  MANAGER_TO_COMPANY: null,
  OWNER_TO_COMPANY: null,
  PARTNER_TO_COMPANY: null,
  RESELLER_TO_COMPANY: null
});

exports.default = _default;
module.exports = exports.default;